import ActionsFactory from './actions';

const getters = {
  isLoggedIn: (state) => state,
  authStatus: (state) => state.status,
};

const state = {
  user: null,
  mUser: null,
  convertAccount: false,
  loggedIn: false,
  redirectUrl: null,
};

function compareValues(key, order = 'asc') {
  // eslint-disable-next-line func-names
  return function (a, b) {
    // eslint-disable-next-line no-prototype-builtins
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
    const comparison = a[key].localeCompare(b[key]);

    return order === 'desc' ? comparison * -1 : comparison;
  };
}

const mutations = {
  authenticate(st, payload) {
    const now = new Date();
    st.user = payload;
    st.tokenExpires = Math.round(now.getTime() / 1000);
    st.convertAccount = false;
    st.loggedIn = true;
    st.initSessionSignIn = now;
    st.maxSessionExpires = Math.round(now.setDate(now.getDate() + 7) / 1000); // expire in 7 days
  },
  updateUserRole(st, payload) {
    if (!payload) {
      return;
    }

    if (st.mUser) {
      st.mUser.role = payload;
    }

    if (st.user) {
      st.user.role = payload;
    }
  },
  updateTokenExpiration(st) {
    const now = new Date();
    st.tokenExpires = Math.round(now.getTime() / 1000 + 120);
  },
  signout(st) {
    st.user = null;
    st.loggedIn = false;
  },
  attributes(st, payload) {
    st.user.attributes = payload;
  },
  convertAccount(st, convert) {
    st.convertAccount = convert;
  },
  setUser(st, user) {
    st.user = user;
  },
  setMUser(st, user) {
    st.mUser = user;
  },
  setRedirectUrl(st, url) {
    st.redirectUrl = url;
  },
  addMembershipRequest(st, request) {
    if (!st.mUser.membership_requests) {
      st.mUser.membership_requests = [];
    }

    st.mUser.membership_requests.push(request);
  },
  updateUserOrg(st, org) {
    if (st.mUser.organizations) {
      const i = st.mUser.organizations.findIndex((o) => o._id === org._id);
      if (i > 0) {
        st.mUser.organizations[i] = org;
      } else {
        st.mUser.organizations.push(org);
      }
    } else {
      st.mUser.organizations = [];
      st.mUser.organizations.push(org);
    }
  },
  sortOrgsLocally(st, sortObject) {
    st.mUser.organizations = st.mUser.organizations.sort(compareValues(sortObject.key, sortObject.order));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions: new ActionsFactory(),
  mutations,
};
